'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const theme_Colors = require('../../../../theme/Colors.cjs.js');
const components_marketing_CTA_CTATextContent = require('../CTATextContent.cjs.js');
const components_marketing_CTA_utils = require('../utils.cjs.js');
const theme_LegacyColorMap = require('../../../../theme/LegacyColorMap.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_1nell_1";
const mediaContent = "_media-content_1nell_27";
const styles = {
	root: root,
	mediaContent: mediaContent
};

const CTAFilled = ({ backgroundColor = "neutral100", children, ctaHref, ctaBtnColor, ctaText, description, heading, maxWidth = 1170, onCtaClick, onCtaKeyDown, subHeading, ctaTarget }) => {
  const bgColor = components_marketing_CTA_utils.getBgColor(backgroundColor);
  return React__default.default.createElement(
    "div",
    { className: styles.root, style: {
      "--_zds-cta-filled-max-width": `${maxWidth}px`,
      "--_zds-cta-filled-bg-color": theme_Colors.Colors[theme_LegacyColorMap.LegacyColorMap[bgColor]]
    }, "data-zds": true },
    React__default.default.createElement(components_marketing_CTA_CTATextContent.CTATextContent, { heading, subHeading, description, ctaText, ctaHref, ctaBtnColor, onCtaClick, onCtaKeyDown, bgColor, ctaTarget }),
    React__default.default.createElement("div", { className: styles.mediaContent, "data-testid": "media-content", "data-zds": true }, children)
  );
};

exports.CTAFilled = CTAFilled;
//# sourceMappingURL=CTAFilled.cjs.js.map
